import { useNavigate } from 'react-router-dom';
import VideoCard from '@/components/feature/VideoCard';
import { videos } from '@/mocks/videos';

export default function LatestVideos() {
  const navigate = useNavigate();
  const latestVideos = [...videos].sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()).slice(0, 8);

  const handleViewAll = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => navigate('/category/reboju'), 150);
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2">最新更新</h2>
            <p className="text-foreground-600 text-sm">最新上线的热门影视剧，追剧快人一步</p>
          </div>
          <button
            onClick={handleViewAll}
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </button>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {latestVideos.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
        <button
          onClick={handleViewAll}
          className="sm:hidden w-full mt-6 py-3 text-sm text-primary-500 font-medium border border-primary-200 rounded-lg hover:bg-primary-50 transition-colors cursor-pointer"
        >
          查看全部
        </button>
      </div>
    </section>
  );
}